import { fetcher } from "helpers/fetcher";

import { TGetSchoolReq, TGetSchoolRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getSchool = async (params: TGetSchoolReq) => {
  return await fetcher<TGetSchoolRes, TGetSchoolReq>(
    ENDPOINT.USER.GET_SCHOOOL,
    {
      params: params,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_SCHOOOL.version,
      },
    }
  );
};

export const queryGetSchool = async (params: TGetSchoolReq) => {
  return (await getSchool(params)).data;
};

queryGetSchool._key = (params: TGetSchoolReq) => [
  ENDPOINT.USER.GET_SCHOOOL.url,
  params,
];
